import * as React from 'react'
import { SVGProps } from 'react'

const SvgNoLockInPeriod = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 281 180"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity={0.3}
      d="M92.596 148.981c43.177 28.692 102.41 49.465 137.534 1.093 31.884-43.88 5.852-104.415-51.114-111.431-24.573-3.033-43.982 13.042-68.665 6.078-24.682-6.964-50.155-28.714-73.08-3.278-35.5 39.389 26.91 88.668 55.325 107.538Z"
      fill="#C2FFE7"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M162.963 73.206c.508-.815.98-1.661 1.411-2.537a35.944 35.944 0 0 1 2.99 2.537h-4.401Zm-43.926 0a29.004 29.004 0 0 1-1.411-2.537 35.264 35.264 0 0 0-7.916 8.337l.208.332 5.636-6.132h3.483Zm53.15 5.965.103-.165a23.108 23.108 0 0 0-.262-.382l.159.547ZM114.5 56.97c0 2.75.341 5.383.973 7.86a41.79 41.79 0 0 0-8.822 8.202c-2.026-4.915-3.151-10.349-3.151-16.062C103.5 34.895 120.289 17 141 17s37.5 17.895 37.5 39.969c0 5.713-1.125 11.146-3.151 16.062a41.787 41.787 0 0 0-8.822-8.202c.632-2.477.973-5.11.973-7.86C167.5 40.299 154.985 28 141 28s-26.5 12.299-26.5 28.969Z"
      fill="#33DC98"
    />
    <circle
      cx={141}
      cy={112.312}
      r={44.5}
      fill="#EDFFF8"
      stroke="#33DC98"
      strokeWidth={11}
    />
    <circle cx={141} cy={112.312} r={6.25} fill="#33DC98" />
    <path
      stroke="#33DC98"
      strokeWidth={5}
      strokeLinecap="round"
      d="M141.625 109.813V82M141.404 115.646l15.43 17.372"
    />
  </svg>
)

export default SvgNoLockInPeriod
